<script setup lang="ts">
import { computed } from "vue";
import Buttons from "../form/Buttons.vue";

const props = withDefaults(
  defineProps<{
    mode: string;
    title: string | null;
    listCreateName?: string;
    noPermission: boolean;
    endPoint?: string;
    modal?: boolean;
    onTour: boolean;
    showEdit?: boolean;
    showSave?: boolean;
    showSaveClose?: boolean;
    showSaveNew?: boolean;
    showTour?: boolean;
    saveCloseCaption?: string;
    saveCloseIcon?: string;
  }>(),
  {
    showTour: true,
    showEdit: true,
    showSave: true,
    showSaveClose: true,
    showSaveNew: true,
    saveCloseCaption: "Save & Close",
    saveCloseIcon: "SaveOff",
  }
);

defineEmits<{
  (e: "handleSubmit", close: boolean, newRecord: boolean): void;
  (e: "close"): void;
  (e: "startTour"): void;
  (e: "handleCancel"): void;
  (e: "handleEdit"): void;
}>();

const fromSelect = computed(() => {
  return props.listCreateName || !props.endPoint?.includes("clients");
});
</script>
<template>
  <div class="w-full pb-3 border-b border-gray-200 dark:border-gray-700" id="form-header">
    <div class="flex justify-between items-center">
      <div id="form-title" class="flex-1 text-left">
        <h3 class="text-lg font-medium text-gray-900 dark:text-white">
          {{ title }}
        </h3>
      </div>
      <div
        class="flex items-center gap-2 mt-2 md:mt-0 text-right"
        id="form-actions"
        v-if="!noPermission"
      >
      <slot name="form-header-buttons"></slot>
        <Buttons
          v-if="!onTour && !fromSelect && showTour"
          caption="Quick Tour"
          icon="BadgeHelp"
          class="hidden md:flex"
          iconColor="red"
          @click="$emit('startTour')"
          id="quick-tour"
        />
        <Buttons
          id="form-edit"
          v-if="mode == 'view' && !fromSelect && showEdit"
          class="h-12 md:h-7"
          @click="$emit('handleEdit')"
          caption="Edit"
          icon="Pencil"
        />
        <Buttons
          id="form-cancel"
          v-if="mode == 'edit' && !fromSelect && showEdit"
          class="h-12 md:h-7"
          @click="$emit('handleCancel')"
          caption="Cancel"
          icon="CircleX"
        />
        <Buttons
          id="form-save-new"
          v-if="mode != 'view' && !fromSelect && modal && showSaveNew"
          class="h-12 md:h-7"
          @click="$emit('handleSubmit', false, true)"
          caption="Save & New"
          icon="FilePlus"
        />
        <Buttons
          id="form-save"
          v-if="mode != 'view' && !fromSelect && showSave"
          @click="$emit('handleSubmit', false, false)"
          caption="Save"
          class="h-12 md:h-7"
          icon="Save"
        />
        <Buttons
          id="form-save-close"
          v-if="mode != 'view' && modal && showSaveClose"
          @click="$emit('handleSubmit', true, false)"
          :caption="saveCloseCaption"
          class="h-12 md:h-7"
          :icon="saveCloseIcon"
        />        
        <Buttons
          id="form-save-close"
          v-if="modal"
          @click="$emit('close')"
          caption="Close"
          class="h-12 md:h-7"
          icon="LogOut"
        />
      </div>
    </div>
  </div>
</template>
